module.exports = __webpack_public_path__ + "assets/veterinary.1892c04b.svg";